import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import EventTwoToneIcon from '@material-ui/icons/Event';
import MomentUtils from '@date-io/moment';
import moment from "moment";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import CustomButton from "./CusomButton";
import MandatorySpan from "../sasl/models/MandatorySpan";

  
const BatchDetails = ({ open,workItemDetails, projectData}) => {
  const [loading, setLoading] = useState(true)
  const [deliverableBatchDetails, setDeliverableBatchDetails] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    const data = {
      collabrixBatchID: projectData.collabrixBatchID
    };

    axios
      .post(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliverableBatchDetails`, data)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setDeliverableBatchDetails(res.data.data.deliverableBatchDetails);
        } else {
          setError("Failed to fetch deliverable batch details.");
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response?.status === 404) {
          setError("Details not found.");
        } else {
          setError("Something went wrong. Please contact Schrocken support.");
        }
      });

  }, [workItemDetails]);

     
// const [startDate, setStartDate] = useState(null);
// const [endDate, setEndDate] = useState(null);
const [expiryDate, setExpiryDate] = useState(null);

useEffect(() => {
  if (deliverableBatchDetails) {
    // setStartDate(deliverableBatchDetails.batchStartDate ? moment(deliverableBatchDetails.batchStartDate) : null);
    // setEndDate(deliverableBatchDetails.batchEndDate ? moment(deliverableBatchDetails.batchEndDate) : null);
    setExpiryDate(deliverableBatchDetails.expiryDate ? moment(deliverableBatchDetails.expiryDate) : null);
  }
}, [deliverableBatchDetails]);
  

  // const handleStartDateChange = (date) => {
  //   setStartDate(date);
  // };
  // const handleEndDateChange = (date) => {
  //   setEndDate(date);
  // };
  const handleExpiryDateChange = (date) => {
    setExpiryDate(date);
  };

return (
   
    <TableRow>
      <TableCell style={{ padding:'2rem' }} colSpan={7}>
        <Collapse in={open} timeout="auto" unmountOnExit>
        {loading === true ? (
                        <div
                        style={{
                          display: "flex",
                          justifyContent: "center", // Horizontally center the CircularProgress
                          alignItems: "center", // Vertically center the CircularProgress
                          height: "100px", // Optional: Set a height to vertically center the loader
                        }}
                      >
                        <CircularProgress />
                      </div>
              ): error ? (
                <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                height: "100px", // Optional: Set a height to vertically center the loader
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                width: "100%",
                }}
              >
                <Typography >{error}</Typography>
              </div>
              ) :(
                deliverableBatchDetails && Object.keys(deliverableBatchDetails).length > 0 ? (
                  <Box margin={1}>
                  <Grid container spacing={3}>
                    <Grid item xs={8}>
                      <TableRow>
                        <TableCell style={{ borderBottom: "none" }}>
                          <Typography variant="subtitle1" style={{ fontWeight: 'bold',paddingBottom:'1rem' }}>Batch Number</Typography>
                          <Typography>
                          {deliverableBatchDetails.batchNumber} 
                          </Typography>
      
                        </TableCell>
                        <TableCell style={{ borderBottom: "none" }}>
                          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Produced Quantity</Typography>
                          <TextField
                          size='small'
                            value={deliverableBatchDetails.producedQuantity}
                            variant="outlined"
                            InputProps={{ readOnly: true }}
                            fullWidth
                          />
                        </TableCell>
                        <TableCell style={{ borderBottom: "none" }}>
                          <Typography variant="subtitle1" style={{ fontWeight: 'bold',paddingBottom:'1rem' }}>Units of Measurement (UoM)</Typography>
                          <Typography>
                          {deliverableBatchDetails.batchUOM}
                          </Typography>
      
                        </TableCell>
                      </TableRow>
      
                      {/* Second Row - Start Date, End Date, Expiry Date */}
                      <TableRow>
                        <TableCell style={{ borderBottom: "none" }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 'bold',paddingBottom:'1rem' }}>Start Date</Typography>
                          <Typography>
                          {deliverableBatchDetails.batchStartDate ? moment(deliverableBatchDetails.batchStartDate).format('DD-MMM-YYYY').toUpperCase() : '-NA-'}
                          </Typography>
      {/* <MuiPickersUtilsProvider utils={MomentUtils}>
              <DatePicker
                fullWidth
                variant='inline'
                inputVariant='outlined'
                format="DD-MMM-YYYY" 
                value={startDate}
                onChange={handleStartDateChange}
                size='small'
                autoOk={true}
                InputProps={{
                  endAdornment: (
                    <EventTwoToneIcon
                      style={{ color: '#0000008a', cursor: 'pointer' }}
                    />
                  ),
                }}
              />
            </MuiPickersUtilsProvider>            */}
       </TableCell>
<TableCell style={{ borderBottom: "none" }}>
<Typography variant="subtitle1" style={{ fontWeight: 'bold',paddingBottom:'1rem' }}>End Date</Typography>
                          <Typography>
                          {deliverableBatchDetails.batchEndDate ? moment(deliverableBatchDetails.batchEndDate).format('DD-MMM-YYYY').toUpperCase() : '-NA-'}
                          </Typography>
  {/* <MuiPickersUtilsProvider utils={MomentUtils}>
              <DatePicker
                fullWidth
                variant='inline'
                inputVariant='outlined'
                format="DD-MMM-YYYY" // Display format
                value={endDate}
                onChange={handleEndDateChange}
                size='small'
                autoOk={true} 
                InputProps={{
                  endAdornment: (
                    <EventTwoToneIcon
                      style={{ color: '#0000008a', cursor: 'pointer' }}
                    />
                  ),
                }}
              />
            </MuiPickersUtilsProvider>  */}
        </TableCell>
         </TableRow>
      
                      {/* Third Row - Storage Location, Storage Condition */}
       <TableRow>
         <TableCell style={{ borderBottom: "none" }}>
          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Storage Location</Typography>
          <TextField
          size='small'
            value={deliverableBatchDetails.storageLocationName}
            variant="outlined"
            InputProps={{ readOnly: true }}
            fullWidth
          />
        </TableCell>
        <TableCell style={{ borderBottom: "none" }}>
          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Storage Condition</Typography>
          <TextField
          size='small'
            value={deliverableBatchDetails.storageCondition}
            variant="outlined"
            InputProps={{ readOnly: true }}
            fullWidth
          />
        </TableCell>
        <TableCell style={{ borderBottom: "none" }}>
          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Expiry Date<span style={{fontWeight:'400'}}><MandatorySpan /></span></Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
              <DatePicker
                fullWidth
                variant='inline'
                inputVariant='outlined'
                format="DD-MMM-YYYY" // Display format
                value={expiryDate}
                onChange={handleExpiryDateChange}
                size='small'
                autoOk={true}
                InputProps={{
                  endAdornment: (
                    <EventTwoToneIcon
                      style={{ color: '#0000008a', cursor: 'pointer' }}
                    />
                  ),
                }}
              />
            </MuiPickersUtilsProvider> 
                        </TableCell>
                      </TableRow>
                    </Grid>
      
                    {/* QA Approval Section */}
                    <Grid item xs={4} style={{ border: '2px solid #D3D3D3',height:'50%',marginTop:'2rem' }}>
                      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        QA Approval for Storage
                      </Typography>
                      <TextField
                        disabled
                      size='medium'
                        placeholder="Enter remarks here"
                        variant="outlined"
                        fullWidth
                        style={{marginTop:'1rem',marginBottom:'1rem'}}
                      //   margin="normal"
                        multiline
                      />
                      <Grid container style={{display:'flex',justifyContent:'space-around',alignItems:'center',flexDirection:'row'}} spacing={2}>
                        <Grid item>
                              <CustomButton
                                  color="#28A745"
                                  textColor="#fff"
                                  style={{width:'7rem' }}
                                >
                                  Approve
                                </CustomButton>

                        </Grid>
                        <Grid item>
                             <CustomButton
                                  color="#DC3545"
                                  textColor="#fff"
                                  style={{width:'7rem' }}
                                >
                                  Reject
                                </CustomButton>
                        </Grid>
                        <Grid item>
                               <CustomButton
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff"
                                  style={{width:'11rem' }}
                                >
                                  Remind CMO Team
                                </CustomButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <div  style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                    height: "100px", // Optional: Set a height to vertically center the loader
            width:'100%'
                }}>
                <Typography style={{textAlign:'center'}}>No Records Found</Typography>
            </div>
                ) 
)}
        </Collapse>
      </TableCell>
    </TableRow>        

  );
};

export default BatchDetails;
